import { Model } from 'rwl-shared';
import { Config } from '../ConfigFetcher/useConfig';
import { LocationInfo } from 'rwl-shared/dist/models';
import {
    GeolocationUpdate,
    PortfolioSessionUpdateRequest,
} from 'rwl-shared/dist/models/portfolio/PortfolioUserSession';

export const TRACKING_SESSION_ID = 'rwl:session:id';
export const TRACKING_SHARE_ID = 'rwl:share:id';

export function createSessionUpdateRequest(
    config: Config,
    geolocation: Model.PluginGeoLocation | 'Unavailable',
    userId?: string
): Model.PortfolioSessionUpdateRequest {
    let location: LocationInfo | undefined;
    if (config.ipInfo) {
        location = {
            city: config.ipInfo?.city,
            state: config.ipInfo?.state,
            zip: config.ipInfo?.zip?.toString(),
        };
    }
    return {
        geolocation: geolocation,
        location: location,
        id: window.localStorage.getItem(TRACKING_SESSION_ID) ?? undefined,
        referrer: document.referrer,
        shareId: window.localStorage.getItem(TRACKING_SHARE_ID) ?? undefined,
        userAgent: window.navigator.userAgent,
        userId: userId,
    };
}

export async function trackSession(
    config: Config,
    url: string,
    geoLocation: GeolocationUpdate,
    userId: string | undefined
): Promise<string> {
    const request = createSessionUpdateRequest(config, geoLocation, userId);
    return await postSessionUpdate(url, request);
}
async function postSessionUpdate(
    url: string,
    request: PortfolioSessionUpdateRequest
) {
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            Accept: 'application.json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(request),
    });
    const body = await response.json();
    const sessionId = body.id;
    if (sessionId) {
        window.localStorage.setItem(TRACKING_SESSION_ID, sessionId);
    }
    return sessionId;
}
